import { put, all, takeLatest } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import API from "../../commonUtils/API.js";
import { toast } from "react-toastify";
import { handleApiError } from "../../commonUtils/Functions";

function* loadClusterStateSaga() {
    try {
        // yield put({ type: actionTypes.SET_CLUSTER_STATE, payload: 0 });
        const { data } = yield API.get("/cluster/status");
        if (data.success) {
            const clusterState = data.data.state === "TERMINATED" ? -1 : data.data.state === "RUNNING" ? 1 : 0;
            yield put({ type: actionTypes.GET_CLUSTER_STATE_SUCCESS, payload: clusterState});
        } else {
            toast.error("Unable to load Cluster State.");
            yield put({ type: actionTypes.GET_CLUSTER_STATE_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Unable to load Cluster State.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.GET_CLUSTER_STATE_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* clusterStartSaga() {
    try {
        yield put({ type: actionTypes.SET_PROCESSING, payload: true });
        yield put({ type: actionTypes.SET_CLUSTER_STATE, payload: 0 });
        const { data } = yield API.post("/cluster/process-start");
        if (data.success) {
            yield put({ type: actionTypes.CLUSTER_START_SUCCESS });
        } else {
            toast.error("Oops! Something went unexpectedly wrong.");
            yield put({ type: actionTypes.CLUSTER_START_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Oops! Something went unexpectedly wrong.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CLUSTER_START_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* clusterStopSaga() {
    try {
        yield put({ type: actionTypes.SET_PROCESSING, payload: true });
        yield put({ type: actionTypes.SET_CLUSTER_STATE, payload: 0 });
        const { data } = yield API.post("/cluster/process-stop");
        if (data.success) {
            yield put({ type: actionTypes.CLUSTER_STOP_SUCCESS });
        } else {
            toast.error("Oops! Something went unexpectedly wrong.");
            yield put({ type: actionTypes.CLUSTER_STOP_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Oops! Something went unexpectedly wrong.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CLUSTER_STOP_FAILURE, payload: data || { message: "Internal server error" } });
    }
};



function* ClusterSaga() {
  yield all([
    takeLatest(actionTypes.GET_CLUSTER_STATE, loadClusterStateSaga),
    takeLatest(actionTypes.CLUSTER_START, clusterStartSaga),
    takeLatest(actionTypes.CLUSTER_STOP, clusterStopSaga),
  ]);
}

export default ClusterSaga;